import cloneDeep from "lodash-es/cloneDeep";
import { codeSchemaFields } from "../utils/code";
const filterItems = [{
  value: '=',
  label: '(=)等于'
}, {
  value: '!=',
  label: '(!=)不等于'
}, {
  value: '>',
  label: '(>)大于'
}, {
  value: '>=',
  label: '(>+)大于等于'
}, {
  value: '<',
  label: '(<)小于'
}, {
  value: '<=',
  label: '(<=)小于等于'
}, {
  value: '%%',
  label: '(%%)类似于'
}, {
  value: '=%',
  label: '(=%)开头等于'
}, {
  value: '%=',
  label: '(%=)结尾等于'
}, {
  value: '!%',
  label: '(!%)不类似'
}];
const filterItemType = {
  type: 'object',
  title: '过滤对象',
  fields: [{
    id: 'k',
    title: '对象的key',
    type: 'string'
  }, {
    id: 'o',
    title: '过滤类型',
    type: 'string',
    enum: filterItems
  }, {
    id: 'v',
    title: 'key对应的值',
    type: 'any'
  }]
};
export const queryFilterFiled = {
  id: 'filter',
  type: 'string',
  required: false,
  title: '过滤参数',
  jsonStringType: {
    type: 'array',
    items: filterItemType
  }
};
export const bodyFilterField = {
  id: 'filter',
  type: 'array',
  required: false,
  title: '过滤参数数组',
  items: filterItemType
};
const pageSizeFields = [{
  id: 'page',
  type: 'string',
  required: false,
  title: '页码'
}, {
  id: 'size',
  type: 'string',
  required: false,
  title: '每页拉取数'
}];
const includeFields = [{
  id: 'include',
  type: 'string',
  required: false,
  title: '显示字段'
}, {
  id: 'exclude',
  type: 'string',
  required: false,
  title: '排除字段'
}];
// 排序参数
export const bodySortField = {
  id: 'sort',
  title: '排序参数',
  type: 'array',
  required: false,
  items: {
    type: 'object',
    fields: [{
      id: 'k',
      type: 'string',
      title: '排序的字段'
    }, {
      id: 'o',
      type: 'string',
      title: 'asc - 正序/desc - 倒序',
      enum: [{
        value: 'asc',
        label: 'asc(正序)'
      }, {
        value: 'desc',
        label: 'desc(倒序)'
      }]
    }]
  }
};
const querySortFields = [{
  id: 'sort',
  type: 'string',
  required: false,
  title: '需要排序的key'
}, {
  id: 'order',
  type: 'string',
  required: false,
  title: '正序(asc)/倒序(desc)'
}];
export const listApiTemplate = {
  name: 'list',
  desc: '列表接口',
  required: false,
  dbMethod: 'list',
  request: {
    query: {
      type: 'object',
      title: 'url参数',
      fields: [...cloneDeep(pageSizeFields), queryFilterFiled, ...cloneDeep(includeFields), ...querySortFields],
      useInDB: true
    },
    body: {
      type: 'object',
      title: 'post参数',
      fields: [...cloneDeep(pageSizeFields), bodyFilterField, ...cloneDeep(includeFields), bodySortField]
    }
  },
  response: {
    body: {
      type: 'object',
      title: '响应body',
      fields: [{
        id: 'data',
        type: 'array',
        title: '列表数据',
        injectEntity: true
      }, {
        id: 'total',
        type: 'number',
        required: false,
        title: '总数(若配置，会替代count接口)'
      }, ...codeSchemaFields, {
        id: 'extra',
        type: 'object',
        required: false,
        title: '额外信息(存放前端可能用到的其他数据)'
      }]
    }
  }
};
//# sourceMappingURL=list.js.map
